<mat-form-field [appearance]="appearance!" #singleSelect>
  <mat-icon matPrefix *ngIf="icon">
    {{ icon }}
  </mat-icon>
  <mat-label>{{ label }}</mat-label>
  <mat-select matNativeControl [formControlName]="name" (selectionChange)="change($event.value)">
    <mat-option *ngFor="let item of items" [value]="item.value">
      {{ item.label }}
    </mat-option>
  </mat-select>
</mat-form-field>
